<template lang="pug">
.container(id="FileUpload-container")
  h3.header {{ $t('Import devices, localizations, tags from a .csv file') }}
  hr.header
  el-progress(v-if='saving !== false && progress > 0', :percentage='progress', color='#0071ff', :show-text='false')
  .form(v-if='saving === false')
    el-form(:inline="true", size='mini')
      el-form-item(label='', v-if='devices.length === 0')
        label.custom-file-upload.el-button.success(for="file-upload")
            span {{ $t('select .csv file') }}
        input(type="file", id='file-upload', @change="onFileChange")
      el-button(v-if='devices.length > 0', type='success', size='mini', @click='submit()')
        span {{ $t('Import') }} {{ files[0].name }}
      el-form-item(:label="$t('csv delimiter')")
        el-input(v-model="csvDelimiter", :placeholder="$t('csv delimiter')", style='width:50px')
      el-form-item(:label="$t('Construct device name from first # of columns')")
        el-input(v-model="concateColumnsForNameCount", :placeholder="$t('Construct device name from first # of columns')", style='width:50px')
      el-form-item(:label="$t('Omit first line in file')")
        el-checkbox(v-model="omitFirstLine", :placeholder="$t('Omit first line in file')")
      el-form-item(:label="$t('Skip existing devices')")
        el-checkbox(v-model="omitExistingDevices", :placeholder="$t('Skip existing devices')")
      el-form-item(:label="$t('Add missing device Tags')")
        el-checkbox(v-model="addMissingDeviceTags", :placeholder="$t('Add missing device Tags')")
      el-form-item(:label='$t("Template")')
        el-select(id="AddMassDevice-templateSelect" v-model='templateId', placeholder='Select', clearable)
          el-option(v-for='template in templates', :key='template.id', :label='template.name', :value='template.id', :id="'AddMassDevice-templateOption' + template.id")
  hr.header
  .section(v-if='devices.length > 0')
    h5 {{ $t('Import Preview') }}
      span(v-if='progress > 0 && progress < 100') &nbsp; {{ progress }}%
      span :
    el-input(v-model="deviceFilterString", :placeholder="$t('Filter preview')", style='width:150px', size='mini')
    .section(v-if='saving === false')
      p {{ devices.length }} {{ $t('devices found in .csv file') }}
      p.warning(v-if='errors.nonUniqueNames') {{ $t('Your file has non-unique names for devices') }}
    .row-csv.header
      .cell.selectable.devicename {{ $t('Device Name') }}
      .cell.selectable.groupname {{ $t('Group Name') }}
      .cell.selectable.groupname {{ $t('Tags') }}
    .row-csv.success(v-if='saving !== false && deviceImported')
      .cell.selectable.devicename {{ deviceImported.devicename }}
      .cell.selectable.groupname {{ deviceImported.groupname }}
      .cell.selectable.tags {{ deviceImported.tags }}
    .row-csv.warning(v-if='errors.nonUniqueNames && saving === false', v-for='(device, index) of duplicatedNamesDevices', :key='index', :id='"device_" + index')
      .cell.selectable.devicename {{ device.devicename }}
      .cell.selectable.groupname {{ device.groupname }}
      .cell.selectable.tags {{ device.tags }}
    .row-csv(v-if='!errors.nonUniqueNames && saving === false', v-for='(device, index) of filteredDevices', :key='index', :id='"device_" + index')
      .cell.selectable.devicename {{ device.devicename }}
      .cell.selectable.groupname {{ device.groupname }}
      .cell.selectable.tags {{ device.tags }}
</template>

<script>
import Vue from 'vue'
export default {
  props: ['mediumId'],
  mixins: [],
  components: {
  },
  async created () {
    this.templates = (await Vue.axios.get('devicetemplate')).data
  },
  watch: {
    concateColumnsForNameCount: async function (newVal, oldVal) {
      this.onFileChange(this.e)
    },
    csvDelimiter: async function (newVal, oldVal) {
      this.onFileChange(this.e)
    },
    omitFirstLine: async function (newVal, oldVal) {
      this.onFileChange(this.e)
    }
  },
  data () {
    return {
      errors: {
        nonUniqueNames: false
      },
      files: undefined,
      fileinput: '',
      devices: [],
      concateColumnsForNameCount: 2,
      csvDelimiter: ';',
      omitFirstLine: true,
      e: undefined,
      duplicatedNamesDevices: [],
      omitExistingDevices: true,
      addMissingDeviceTags: true,
      templates: [],
      templateId: 1,
      saving: false,
      progress: 0,
      deviceImported: undefined,
      deviceFilterString: ''
    }
  },
  methods: {
    async submit () {
      this.saving = 0
      for (const device of this.devices) {
        const allTags = [...this.$store.state.Device.device_tags, ...this.$store.state.Device.device_tags_unused]
        const existingDevicesWithName = (await Vue.axios.get(`device?name=${device.devicename}`)).data
        if (this.omitExistingDevices && existingDevicesWithName.length > 0) {
          this.saving++
          this.progress = ((this.saving / this.devices.length) * 100).toFixed(2)
          continue
        }
        this.deviceImported = device
        // Device
        let newOrExistingDevice
        if (existingDevicesWithName.length === 0) {
          newOrExistingDevice = (await Vue.axios
            .post('deviceTemplate/createDeviceFromDeviceTemplate',
              { name: device.devicename, deviceTemplate: this.templateId }))
            .data
        } else {
          newOrExistingDevice = existingDevicesWithName[0]
        }
        // DeviceDesktopGroup
        let deviceDesktopGroup
        deviceDesktopGroup = (await Vue.axios.get(`devicedesktopgroup?name=${device.groupname}`)).data[0]
        if (!deviceDesktopGroup) {
          deviceDesktopGroup = (await Vue.axios.post(`devicedesktopgroup`, {
            name: device.groupname
          })).data
        }
        await this.$store.dispatch('Device/assignDesktopToGroup', [newOrExistingDevice.DeviceDesktops[0].id, deviceDesktopGroup.id])
        // TAGS
        const matchingTagsIds = []
        for (const tag of device.tags.split(', ')) {
          const existingTag = allTags.find(at => at.name === tag)
          if (existingTag) {
            matchingTagsIds.push(existingTag.id)
          } else {
            if (this.addMissingDeviceTags) {
              console.log('creating devicetag', tag)
              const newDeviceTag = await this.$store.dispatch('Device/addDeviceTag', tag)
              matchingTagsIds.push(newDeviceTag.id)
            }
          }
        }
        await this.$store.dispatch('Device/replaceDeviceTagsInDevice', [matchingTagsIds, newOrExistingDevice.id])
        this.saving++
      }
      this.saving = false
    },
    onFileChange (e) {
      this.errors.nonUniqueNames = false
      this.duplicatedNamesDevices = []
      this.e = e
      this.files = e.target.files || e.dataTransfer.files
      if (!this.files.length) return
      this.createInput(this.files[0])
    },
    createInput (file) {
      let promise = new Promise((resolve, reject) => {
        let reader = new FileReader()
        let vm = this
        reader.onload = e => {
          resolve((vm.fileinput = reader.result))
        }
        reader.readAsText(file)
      })

      promise.then(
        result => {
          this.devices = []
          for (let device of this.fileinput.split('\n')) {
            if (device.length === 0) continue
            device = device.split(this.csvDelimiter)
            let devicename = []
            for (let i = 0; i < this.concateColumnsForNameCount; i++) {
              devicename.push(device[i])
            }
            const deviceObject = {
              devicename: devicename.join('_'),
              groupname: device[0],
              tags: device.slice(1).filter(t => t !== '').join(', ')
            }
            this.devices.push(deviceObject)
          }
          if (this.omitFirstLine) this.devices.shift()
          // Check if there are duplicate names in imported devices and warn if so
          if (this.devices.length !== [...new Set(this.devices.map(d => d.devicename))].length) {
            this.errors.nonUniqueNames = true
            this.duplicatedNamesDevices = this.devices.filter((device) => {
              return this.devices.filter(d => d.devicename === device.devicename).length > 1
            })
          }
        },
        error => {
          console.log(error)
        }
      )
    }
  },
  computed: {
    filteredDevices () {
      if (this.deviceFilterString.length > 0) {
        return this.devices.filter(d => d.name.indexOf(this.deviceFilterString) > -1)
      }
      return this.devices
    }
  }
}
</script>
<style lang="scss">
@import "../../../theme-m4b/src/common/var.scss";
.row-csv {
  display: flex;
  margin: 5px 0px;
  .cell {
    width: 30%;
    font-size: $--font-size-base;
  }
  &.header {
    color: $--color-text-secondary;
    font-size: 24px;
    border-bottom: $--border-light;
  }
}
.form-container {
  display: flex;
}
input[type="file"] {
    display: none;
}
.custom-file-upload {
    border: 0px;
    display: flex;
    align-items: center;
    font-size: $--font-size-base;
    color: white;
    background-color: $--color-success;
    margin: 2px 16px 0px -15px;
    height: 25px;
    padding: 0px 10px;
    cursor: pointer;
}
.el-form-item {
  padding: 0px 15px;
}
.form {
  margin: 0;
  padding: 0;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Device/AddFromCSV.vue